/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Integration_Harden_Output6Inputs */

const en_svc_ai_integration_harden_output6 = /** @type {(inputs: Svc_Ai_Integration_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quality dashboard`)
};

const ar_svc_ai_integration_harden_output6 = /** @type {(inputs: Svc_Ai_Integration_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لوحة مراقبة الجودة`)
};

const bn_svc_ai_integration_harden_output6 = /** @type {(inputs: Svc_Ai_Integration_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কোয়ালিটি ড্যাশবোর্ড`)
};

const de_svc_ai_integration_harden_output6 = /** @type {(inputs: Svc_Ai_Integration_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualitäts-Dashboard`)
};

const es_svc_ai_integration_harden_output6 = /** @type {(inputs: Svc_Ai_Integration_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel de calidad`)
};

const fr_svc_ai_integration_harden_output6 = /** @type {(inputs: Svc_Ai_Integration_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tableau de bord qualité`)
};

const pt_svc_ai_integration_harden_output6 = /** @type {(inputs: Svc_Ai_Integration_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Painel de qualidade`)
};

const zh_svc_ai_integration_harden_output6 = /** @type {(inputs: Svc_Ai_Integration_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`质量看板`)
};

const tr_svc_ai_integration_harden_output6 = /** @type {(inputs: Svc_Ai_Integration_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalite kontrol paneli`)
};

const ru_svc_ai_integration_harden_output6 = /** @type {(inputs: Svc_Ai_Integration_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Панель управления качеством`)
};

const pl_svc_ai_integration_harden_output6 = /** @type {(inputs: Svc_Ai_Integration_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel jakości`)
};

/**
* | output |
* | --- |
* | "Quality dashboard" |
*
* @param {Svc_Ai_Integration_Harden_Output6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_integration_harden_output6 = /** @type {((inputs?: Svc_Ai_Integration_Harden_Output6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Integration_Harden_Output6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_integration_harden_output6(inputs)
	if (locale === "bn") return bn_svc_ai_integration_harden_output6(inputs)
	if (locale === "de") return de_svc_ai_integration_harden_output6(inputs)
	if (locale === "es") return es_svc_ai_integration_harden_output6(inputs)
	if (locale === "fr") return fr_svc_ai_integration_harden_output6(inputs)
	if (locale === "pt") return pt_svc_ai_integration_harden_output6(inputs)
	if (locale === "zh") return zh_svc_ai_integration_harden_output6(inputs)
	if (locale === "tr") return tr_svc_ai_integration_harden_output6(inputs)
	if (locale === "ru") return ru_svc_ai_integration_harden_output6(inputs)
	if (locale === "pl") return pl_svc_ai_integration_harden_output6(inputs)
	return en_svc_ai_integration_harden_output6(inputs)
});
export { svc_ai_integration_harden_output6 as "svc_ai-integration_HARDEN_output" }